export class User {

    public constructor() { }

    id?: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    companyName: string;
    phone: string;
    userType: string;
    zipCode: string;
}



// WEBPACK FOOTER //
// ./src/app/user/user.ts